"use client";

import { c as _c } from "react/compiler-runtime";
import type { MemeSeason } from "@/entities/ISeason";
import { commonApiFetch } from "@/services/api/common-api";
import { useAnimate } from "framer-motion";
import { useEffect, useMemo, useRef, useState } from "react";
import SeasonsGridDropdownItemsWrapper from "./SeasonsGridDropdownItemsWrapper";
interface SeasonsGridDropdownProps {
  readonly selected: MemeSeason | null;
  readonly setSelected: (season: MemeSeason | null) => void;
  readonly initialSeasonId?: number | null | undefined;
  readonly disabled?: boolean | undefined;
}
export default function SeasonsGridDropdown(t0) {
  const $ = _c(53);
  const {
    selected,
    setSelected,
    initialSeasonId,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const [isOpen, setIsOpen] = useState(false);
  const [iconScope, animateIcon] = useAnimate();
  const buttonRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [seasons, setSeasons] = useState(t2);
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const abortController = new AbortController();
      commonApiFetch({
        endpoint: "new_memes_seasons",
        signal: abortController.signal
      }).then(response => {
        setSeasons(response);
      }).catch(_temp);
      return () => {
        abortController.abort();
      };
    };
    t4 = [];
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  const activeSeasonId = selected?.id ?? initialSeasonId ?? null;
  let t5;
  if ($[3] !== activeSeasonId || $[4] !== seasons) {
    t5 = seasons.find(season => season.id === activeSeasonId) ?? null;
    $[3] = activeSeasonId;
    $[4] = seasons;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const activeSeason = t5;
  let t6;
  let t7;
  if ($[6] !== animateIcon || $[7] !== iconScope || $[8] !== isOpen) {
    t6 = () => {
      if (!iconScope.current) {
        return;
      }
      if (isOpen) {
        animateIcon(iconScope.current, {
          rotate: 0
        });
      } else {
        animateIcon(iconScope.current, {
          rotate: -90
        });
      }
    };
    t7 = [animateIcon, iconScope, isOpen];
    $[6] = animateIcon;
    $[7] = iconScope;
    $[8] = isOpen;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let t8;
  if ($[11] !== activeSeason || $[12] !== selected) {
    t8 = () => {
      if (selected !== null) {
        return selected.display;
      }
      if (activeSeason !== null) {
        return activeSeason.display;
      }
      return "All Seasons";
    };
    $[11] = activeSeason;
    $[12] = selected;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const getLabel = t8;
  let t9;
  if ($[14] !== setSelected) {
    t9 = season_0 => {
      setSelected(season_0);
      setIsOpen(false);
    };
    $[14] = setSelected;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const onSelect = t9;
  let t10;
  if ($[16] !== getLabel) {
    t10 = getLabel();
    $[16] = getLabel;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = `Season: ${t10}`;
  let t12;
  if ($[18] !== isOpen) {
    t12 = () => setIsOpen(!isOpen);
    $[18] = isOpen;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = `${disabled ? "tw-opacity-50 tw-text-iron-400" : "hover:tw-ring-iron-600 tw-text-iron-300"} tw-bg-iron-800 lg:tw-bg-iron-900 tw-py-3 tw-w-full tw-truncate tw-text-left tw-relative tw-block tw-whitespace-nowrap tw-rounded-lg tw-border-0 tw-pl-3.5 tw-pr-10 tw-font-semibold tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 
          focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-text-xs hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out tw-justify-between`;
  let t14;
  if ($[20] !== getLabel) {
    t14 = getLabel();
    $[20] = getLabel;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== iconScope) {
    t16 = <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center -tw-mr-1 tw-pr-3.5"><svg ref={iconScope} className="tw-h-5 tw-w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t15}</svg></div>;
    $[23] = iconScope;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== disabled || $[26] !== isOpen || $[27] !== t11 || $[28] !== t12 || $[29] !== t13 || $[30] !== t14 || $[31] !== t16) {
    t17 = <div className="tw-relative tw-w-full"><button ref={buttonRef} type="button" aria-haspopup="true" aria-label={t11} aria-expanded={isOpen} onClick={t12} disabled={disabled} className={t13}>{t14}{t16}</button></div>;
    $[25] = disabled;
    $[26] = isOpen;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== onSelect) {
    t18 = () => onSelect(null);
    $[33] = onSelect;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  const t19 = `tw-col-span-full tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-x-2 tw-rounded-md tw-border tw-border-solid tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition tw-duration-200 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 ${activeSeasonId === null ? "tw-bg-primary-500/20 tw-border-primary-500 tw-text-primary-300" : "tw-bg-transparent tw-border-iron-700 tw-text-iron-200 hover:tw-bg-iron-800"}`;
  let t20;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span>All Seasons</span>;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t18 || $[37] !== t19) {
    t21 = <button type="button" onClick={t18} className={t19} role="menuitem">{t20}</button>;
    $[36] = t18;
    $[37] = t19;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== activeSeasonId || $[40] !== onSelect || $[41] !== seasons) {
    let t23;
    if ($[43] !== activeSeasonId || $[44] !== onSelect) {
      t23 = season_1 => <button key={season_1.id} type="button" onClick={() => onSelect(season_1)} className={`tw-flex tw-items-center tw-justify-center tw-gap-x-1 tw-rounded-md tw-border tw-border-solid tw-px-2 tw-py-2 tw-text-sm tw-font-medium tw-transition tw-duration-200 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 ${activeSeasonId === season_1.id ? "tw-bg-primary-500/20 tw-border-primary-500 tw-text-primary-300" : "tw-bg-transparent tw-border-iron-700 tw-text-iron-200 hover:tw-bg-iron-800"}`} role="menuitem"><span>{season_1.display}</span></button>;
      $[43] = activeSeasonId;
      $[44] = onSelect;
      $[45] = t23;
    } else {
      t23 = $[45];
    }
    t22 = seasons.map(t23);
    $[39] = activeSeasonId;
    $[40] = onSelect;
    $[41] = seasons;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[46] !== isOpen || $[47] !== t21 || $[48] !== t22) {
    t23 = <SeasonsGridDropdownItemsWrapper isOpen={isOpen} setOpen={setIsOpen} buttonRef={buttonRef} filterLabel="Season">{t21}{t22}</SeasonsGridDropdownItemsWrapper>;
    $[46] = isOpen;
    $[47] = t21;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t17 || $[51] !== t23) {
    t24 = <div className="tailwind-scope tw-w-full tw-h-full">{t17}{t23}</div>;
    $[50] = t17;
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  return t24;
}
function _temp(error) {
  if (error instanceof DOMException && error.name === "AbortError") {
    return;
  }
  console.error("Failed to fetch meme seasons:", error);
}